import { ActivityTypeKey } from "@/types/activity"

export const DEFAULT_COVERAGE_OPTIONS = [
  {
    label: "training",
    value: ActivityTypeKey.training,
  },
  {
    label: "cup",
    value: ActivityTypeKey.cup,
  },
  {
    label: "league",
    value: ActivityTypeKey.league,
  },
  {
    label: "friendlyMatch",
    value: ActivityTypeKey.friendlyMatch,
  },
  {
    label: "rehab",
    value: ActivityTypeKey.rehab,
  },
  {
    label: "etc",
    value: ActivityTypeKey.etc,
  },
]
